import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import SponsorInfoTab from './sponsorInfo/SponsorInfoTab';
import SponsorUsersTab from './users/SponsorUsersTab';
import * as Help from 'modules/app/Help'
import queryString from 'query-string';

class SponsorSetup extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		var params = queryString.parse(this.props.location.search);

		return {
			activeTab: (Object.keys(params).length !== 0 && params.tabKey != null ? params.tabKey : "sponsorInfo")
		};
	}

	handleTabSelect = (key) => {
		this.setState({
			activeTab: key
		})
	}

	render() {
		var tabs = [
			{ key: "sponsorInfo", title: "Corporate Member Info", comp: SponsorInfoTab, helpKey: Help.sponsorSetupInfoHelpKey },
			{ key: "sponsorUsers", title: "Users", comp: SponsorUsersTab, helpKey: Help.sponsorSetupUsersHelpKey },
		];

		let sponsorSetupTabs = tabs.map(tab => {
			const Comp = tab.comp;
			const active = (this.state.activeTab === tab.key);

			return (
				<Tab key={tab.key} eventKey={tab.key} title={tab.title}>
					<div className='tab-pane'>
						<div className='panel-body'>
							{this.state.activeTab === tab.key &&
								<Comp tabKey={tab.key}
									active={active}
									helpKey={tab.helpKey}
									selectedId={this.props.selectedId}
									title={tab.title} />}
						</div>
					</div>
				</Tab>
			);
		});

		return (
			<React.Fragment>
				<ContentHeader title="Corporate Member" description="Manage Corporate Member info & associated users" />
				<ContentBody>
					<Tabs id="dashboardTabs"
						className="tabs-container"
						onSelect={this.handleTabSelect}
						defaultActiveKey={this.state.activeTab} >
						{sponsorSetupTabs}
					</Tabs>
				</ContentBody>
			</React.Fragment>
		);
	}
}
export default SponsorSetup;



// WEBPACK FOOTER //
// ./src/areas/sponsor/sponsorSetup/SponsorSetup.js